module.exports = __webpack_public_path__ + "img/21_36.31bc916c.png";